<template>
    <v-card
        tile
        class="data-protection"
    >
        <v-card-title>
            <h1>Datenschutzerklärung für den Einsatz von Trendmanager</h1>
        </v-card-title>
        <v-card-text>
            <h3>Verarbeitung personenbezogener Daten durch den Betreiber (Auftragsverarbeiter TRENDONE GmbH)</h3>

            <p>
                Trendmanager wird unseren Kunden zur Verfügung gestellt. Das bedeutet, dass bestimmte Verarbeitungen im Auftrag
                des jeweiligen Kunden durchgeführt werden, um Ihnen die Möglichkeit zu geben Trendmanager zu nutzen. In diesem
                Fall ist die TRENDONE GmbH der Auftragsverarbeiter und der Kunde ist für die Verarbeitung Ihrer Daten
                verantwortlich.
            </p>

            <p>
                Trendmanager wird von der TRENDONE GmbH (Gasstraße 2, 22761 Hamburg, Deutschland) betrieben
                (<a href="https://www.trendone.com/impressum" target="_blank">https://www.trendone.com/impressum</a>). TRENDONE
                GmbH ist lediglich Betreiber von Trendmanager und in dem Zusammenhang Auftragsverarbeiter nach Art. 28 DS-GVO.
                Die Grundlage für die Verarbeitung durch TRENDONE GmbH ist hierbei ein Vertrag zur Auftragsverarbeitung zwischen
                der verantwortlichen Stelle und TRENDONE GmbH. Zudem verarbeitet die TRENDONE GmbH zur Erbringung dieser
                Dienstleistungen, insbesondere für den Betrieb von Trendmanager, weitere Daten, die auch personenbezogene Daten
                sein können. Darauf wird im Folgenden näher eingegangen.
            </p>

            <h3>Bewertung von Trends</h3>

            <p>
                Über diese Plattform können unsere Kunden Trendradare erstellen. Dies erfolgt
                durch die Bewertung von Trends. Über einen Link kann diese Bewertung
                durchgeführt werden, welche grundsätzlich anonym erfolgt. Bei dieser
                öffentlichen Bewertung werden keine personenbezogenen Daten von Ihnen
                erhoben.
            </p>

            <h3>Personalisierung und Zuordnung von Bewertungen</h3>

            <p>
                Optional kann diese Bewertung auch personalisiert erfolgen. Hierfür werden
                personenbezogene Daten (Vorname, Nachname, E-Mail-Adresse) erhoben, um
                den Zweck, eine einer bestimmten Person zuordenbare Bewertung zu erhalten,
                zu erfüllen.
                Diese Bewertung in personalisierter Form ist optional, und erfolgt auf der
                Rechtsgrundlage der Einwilligung nach Art. 6 Abs. 1 lit a) DSGVO.
            </p>

            <p>
                Die Einwilligung in die Erhebung und Verarbeitung Ihrer personenbezogenen
                Daten zur personalisierten Bewertung kann verweigert werden, wodurch die
                Teilnahme an der Bewertung anonym erfolgen kann. Da in diesem Fall dann
                kein Rückschluss auf eine konkrete natürliche Person möglich ist, ist die DSGVO
                auf diesen Vorgang nicht anwendbar.
            </p>

            <h3>Zugriff auf und Speicherung von Informationen in Endeinrichtungen</h3>

            <p>
                Durch die Nutzung von Trendmanager kann ein Zugriff auf Informationen (z.B. IP-Adresse) oder eine Speicherung
                von Informationen (z.B. Cookies) in Ihren Endeinrichtungen erfolgen. Mit diesem Zugriff bzw. dieser Speicherung
                kann eine weitere Verarbeitung personenbezogener Daten im Sinne der DSGVO verbunden sein. In den Fällen, in
                denen ein solcher Zugriff auf Informationen bzw. ein solches Speichern von Informationen zur technisch
                fehlerfreien Bereitstellung unserer Dienste unbedingt erforderlich ist, erfolgt dies auf Grundlage von § 25 Abs.
                1 S. 1, Abs. 2 Nr. 2 TTDSG.
            </p>

            <p>
                In den Fällen, in denen ein solcher Vorgang anderen Zwecken (z.B. der bedarfsgerechten Gestaltung unserer
                Website) dient, erfolgt dieser auf Grundlage von § 25 Abs. 1 TTDSG nur mit Ihrer Einwilligung gemäß Art. 6 Abs.
                1 lit. a DSGVO. Die Einwilligung ist jederzeit für die Zukunft widerrufbar. Für die Verarbeitung Ihrer
                personenbezogenen Daten gelten die Vorgaben der DSGVO und des Bundesdatenschutzgesetzes (BDSG).
            </p>

            <h3>Webhosting</h3>

            <p>
                Trendmanager wird bei einem externen Dienstleister gehostet. Das Hosting erfolgt in Deutschland.
                Personenbezogene Daten, die auf Trendmanager erfasst werden, werden auf den Servern des Hosters gespeichert.
                Hierbei kann es sich v. a. um IP-Adressen, Kontaktanfragen, Meta- und Kommunikationsdaten, Websiteszugriffe und
                sonstige Daten handeln. Die aufgelisteten Daten erheben wir, um einen reibungslosen Verbindungsaufbau der
                Website und eine technisch fehlerfreie Bereitstellung unserer Dienste gewährleisten zu können. Die Verarbeitung
                dieser Daten ist unbedingt erforderlich, um Ihnen Trendmanager zur Verfügung zu stellen.
            </p>

            <h3>Server-Logfiles</h3>

            <p>
                Wenn Sie Trendmanager aufrufen, ist es technisch notwendig, dass über Ihren Internetbrowser Daten an unseren
                Webserver übermittelt werden. Folgende Daten werden während einer laufenden Verbindung zur Kommunikation
                zwischen Ihrem Internetbrowser und unserem Server aufgezeichnet:
            </p>

            <ul>
                <li>Datum und Uhrzeit der Anforderung</li>
                <li>Name der angeforderten Datei</li>
                <li>Seite, von der aus die Datei angefordert wurde</li>
                <li>Zugriffsstatus</li>
                <li>Verwendeter Webbrowser und verwendetes Betriebssystem</li>
                <li>Übertragene Datenmenge</li>
            </ul>

            <p>
                Die aufgelisteten Daten erheben wir, um einen reibungslosen Verbindungsaufbau und eine technisch fehlerfreie
                Bereitstellung unseres Dienstes gewährleisten zu können. Die Verarbeitung dieser Daten ist unbedingt
                erforderlich, um Ihnen Trendmanager zur Verfügung zu stellen. Die Logdateien dienen der Auswertung der
                Systemsicherheit und -stabilität sowie administrativen Zwecken.
            </p>

            <p>
                Aus Gründen der technischen Sicherheit, insbesondere zur Abwehr von Angriffsversuchen auf unseren Webserver,
                werden diese Daten von uns kurzzeitig gespeichert und nach 7 Tagen gelöscht.
            </p>

            <h3>Cookies</h3>

            <p>
                Trendmanager verwendet sogenannte „Cookies“. Cookies sind kleine Textdateien, die entweder vorübergehend für die
                Dauer einer Sitzung (Session-Cookies) oder dauerhaft (permanente Cookies) auf Ihrem Endgerät gespeichert werden.
                Session-Cookies werden nach Ende Ihres Besuchs automatisch gelöscht. Permanente Cookies bleiben auf Ihrem
                Endgerät gespeichert bis Sie diese selbst löschen oder eine automatische Lösung durch Ihren Webbrowser erfolgt.
                Cookies haben verschiedene Funktionen. Zahlreiche Cookies sind technisch notwendig, da bestimmte
                Webseitenfunktionen ohne diese nicht funktionieren würden. Andere Cookies dienen dazu, das Nutzerverhalten
                auszuwerten oder Werbung anzuzeigen.
            </p>

            <p>
                Die Verarbeitung von Daten durch den Einsatz unbedingt erforderlicher Cookies erfolgt auf Basis eines
                berechtigten Interesses gemäß Art. 6 Abs. 1 lit. f DSGVO an der technisch fehlerfreien Bereitstellung unserer
                Dienste.
            </p>

            <p>
                Die Verarbeitung personenbezogener Daten durch den Einsatz anderer Cookies erfolgt auf Grundlage einer
                Einwilligung gemäß Art. 6 Abs. 1 lit. a DSGVO. Die Einwilligung ist jederzeit für die Zukunft widerrufbar.
                Soweit solche Cookies zu Analyse- und Optimierungszwecken eingesetzt werden, werden wir Sie hierüber im Rahmen
                dieser Datenschutzerklärung gesondert informieren und eine Einwilligung gemäß Art. 6 Abs. 1 lit. a DSGVO
                einholen.
            </p>

            <p>
                Sie können Ihren Browser so einstellen, dass Sie
            </p>

            <ul>
                <li>über das Setzen von Cookies informiert werden,</li>
                <li>Cookies nur im Einzelfall erlauben,</li>
                <li>die Annahme von Cookies für bestimmte Fälle oder generell ausschließen,</li>
                <li>das automatische Löschen der Cookies beim Schließen des Browsers aktivieren.</li>
            </ul>

            <p>
                Die Cookie-Einstellungen können unter den folgenden Links für die jeweiligen Browser verwaltet werden:
            </p>

            <ul>
                <li>
                    <a
                        href="https://support.google.com/chrome/answer/95647?hl=de&hlrm=en"
                        target="_blank"
                    >
                        Google Chrome
                    </a>
                </li>
                <li>
                    <a
                        href="https://support.mozilla.org/de/kb/verbesserter-schutz-aktivitatenverfolgung-desktop?redirectslug=cookies-erlauben-und-ablehnen&redirectlocale=de"
                        target="_blank"
                    >
                        Mozilla Firefox
                    </a>
                </li>
                <li>
                    <a
                        href="https://support.microsoft.com/de-de/windows/verwalten-von-cookies-in-microsoft-edge-anzeigen-zulassen-blockieren-l%C3%B6schen-und-verwenden-168dab11-0753-043d-7c16-ede5947fc64d"
                        target="_blank"
                    >
                        Edge (Microsoft)
                    </a>
                </li>
                <li>
                    <a
                        href="https://support.apple.com/de-de/guide/safari/sfri11471/mac"
                        target="_blank"
                    >
                        Safari
                    </a>
                </li>
                <li>
                    <a
                        href="https://help.opera.com/de/latest/security-and-privacy/#tracking"
                        target="_blank"
                    >
                        Opera
                    </a>
                </li>
            </ul>

            <p>
                Sie können Cookies vieler Unternehmen und Funktionen, die für Werbung eingesetzt werden, auch einzeln verwalten.
                Verwenden Sie dazu die entsprechenden Nutzer-Tools, abrufbar unter
                <a href="https://www.aboutads.info/choices/" target="_blank">https://www.aboutads.info/choices/</a> oder
                <a href="https://www.youronlinechoices.com/uk/your-ad-choices" target="_blank">https://www.youronlinechoices.com/uk/your-ad-choices</a>.
            </p>

            <p>
                Die meisten Browser bieten zudem eine sog. „Do-Not-Track-Function“ an. Wenn diese Funktion aktiviert ist, teilt
                der jeweilige Browser Werbenetzwerken, Websites und Anwendungen mit, dass Sie nicht zwecks verhaltensbasierter
                Werbung und Ähnlichem „verfolgt“ werden möchten.
            </p>

            <p>
                Informationen und Anleitungen, wie Sie diese Funktion bearbeiten können, erhalten Sie je nach Anbieter Ihres
                Browsers, unter den nachfolgenden Links:
            </p>

            <ul>
                <li>
                    <a
                        href="https://support.google.com/chrome/answer/2790761?co=GENIE.Platform%3DDesktop&hl=de"
                        target="_blank"
                    >
                        Google Chrome
                    </a>
                </li>
                <li>
                    <a
                        href="https://support.mozilla.org/de/kb/wie-verhindere-ich-dass-websites-mich-verfolgen"
                        target="_blank"
                    >
                        Mozilla Firefox
                    </a>
                </li>
                <li>
                    <a
                        href="https://support.microsoft.com/de-de/windows/verwenden-von-do-not-track-in-internet-explorer-11-ad61fa73-d533-ce96-3f64-2aa3a332e792"
                        target="_blank"
                    >
                        Edge (Microsoft)
                    </a>
                </li>
                <li>
                    <a
                        href="https://support.apple.com/de-de/guide/safari/sfri40732/13.0/mac/10.15"
                        target="_blank"
                    >
                        Safari
                    </a>
                </li>
                <li>
                    <a
                        href="https://help.opera.com/de/latest/security-and-privacy/"
                        target="_blank"
                    >
                        Opera
                    </a>
                </li>
            </ul>

            <p>
                Zusätzlich können Sie standardmäßig das Laden sog. Scripts verhindern. „NoScript“ erlaubt das Ausführen von
                JavaScripts, Java und anderen Plug-ins nur bei vertrauenswürdigen Domains Ihrer Wahl. Informationen und
                Anleitungen, wie Sie diese Funktion bearbeiten können, erhalten Sie über den Anbieter Ihres Browsers (z.B. für
                Mozilla Firefox unter:
                <a href="https://addons.mozilla.org/de/firefox/addon/noscript/" target="_blank">https://addons.mozilla.org/de/firefox/addon/noscript/</a>).
            </p>

            <p>
                Bitte beachten Sie, dass bei der Deaktivierung von Cookies die Funktionalität unserer Website eingeschränkt sein
                kann.
            </p>

            <h3>Einsatz von Matomo</h3>

            <p>
                Auf dieser Website werden unter Einsatz der Webanalysedienst-Software Matomo (www.matomo.org), einem Dienst des
                Anbieters InnoCraft Ltd., 150 Willis St, 6011 Wellington, Neuseeland, („Matomo“) gem. Art. 6 Abs. 1 lit. a DSGVO
                auf der Grundlage der von Ihnen erteilten Einwilligung zur statistischen Analyse des Nutzerverhaltens zu
                Optimierungs- und Marketingzwecken Daten gesammelt und gespeichert.
            </p>

            <p>
                Bei dem Einsatz von Matomo können Cookies eingesetzt werden. Bei Cookies handelt es sich um kleine Textdateien,
                die lokal im Zwischenspeicher des Internet-Browsers des Seitenbesuchers gespeichert werden. Die Cookies
                ermöglichen unter anderem die Wiedererkennung des Internet-Browsers. Aus diesen Daten können zum selben Zweck
                pseudonymisierte Nutzungsprofile erstellt und ausgewertet werden.
            </p>

            <p>
                Die mit der Matomo-Technologie erhobenen Daten (einschließlich Ihrer pseudonymisierten IP-Adresse) werden nur
                auf unseren Servern verarbeitet. Eine Weitergabe der erfassten Daten an Dritte, auch an Matomo, erfolgt nicht.
            </p>

            <p>
                Die Daten werden gelöscht, sobald sie für die Erreichung des Zweckes ihrer Erhebung nicht mehr erforderlich
                sind. Eine Löschung der Daten auf Nutzer- und Ereignisebene, die mit Cookies, Nutzerkennungen (z. B. User-ID)
                und Werbe-IDs (z. B. DoubleClick-Cookies, Android-Werbe-ID, IDFA) verknüpft sind, erfolgt spätestens nach
                24 Monaten.
            </p>

            <p>
                Die durch das Cookie erzeugten Informationen im pseudonymen Nutzerprofil werden nicht dazu benutzt, den Besucher
                dieser Website persönlich zu identifizieren und nicht mit personenbezogenen Daten über den Träger des Pseudonyms
                zusammengeführt.
            </p>

            <p>
                Wenn Sie mit der Speicherung und Auswertung dieser Daten aus Ihrem Besuch nicht einverstanden sind, dann können
                Sie die Einwilligung in die Speicherung und Nutzung nachfolgend per Mausklick jederzeit widerrufen. In diesem
                Fall wird in Ihrem Browser ein sog. Opt-Out-Cookie abgelegt, was zur Folge hat, dass keinerlei Sitzungsdaten
                erhoben werden. Bitte beachten Sie, dass die vollständige Löschung Ihrer Cookies zur Folge hat, dass auch das
                Opt-Out-Cookie gelöscht wird und ggf. von Ihnen erneut aktiviert werden muss.
            </p>

            <div class="d-inline-block">
                <v-switch
                    :input-value="false"
                    :readonly="true"
                    label="Matomo ist deaktiviert"
                />
            </div>

            <h3>Datensicherheit</h3>

            <p>
                Wir treffen nach Maßgabe des Art. 32 DSGVO unter Berücksichtigung des Stands der Technik, der
                Implementierungskosten und der Art, des Umfangs, der Umstände und der Zwecke der Verarbeitung sowie der
                unterschiedlichen Eintrittswahrscheinlichkeit und Schwere des Risikos für die Rechte und Freiheiten natürlicher
                Personen, geeignete technische und organisatorische Maßnahmen, um ein dem Risiko angemessenes Schutzniveau zu
                gewährleisten. Diese Website nutzt aus Gründen der Sicherheit und zum Schutz der Übertragung vertraulicher
                Inhalte eine SSL-Verschlüsselung.
            </p>

            <h3>Geltendmachung Ihrer Rechte als Betroffener</h3>

            <p>
                Wenn Sie Ihre Rechte als Betroffener im Zusammenhang mit der Nutzung der Plattform geltend machen wollen, können
                Sie sich unter den oben angegebenen Kontaktdaten an uns wenden. Bitte beachten Sie, dass wir Ihre Anfrage an den
                jeweiligen Verantwortlichen zur Beantwortung weiterleiten, wenn wir nicht der für die Verarbeitung
                Verantwortliche sind, wie oben beschrieben.
            </p>

            <h3>Abschließende Bestimmungen</h3>

            <p>
                Wir behalten uns vor, diese Datenschutzerklärung erforderlichenfalls unter Beachtung der geltenden
                Datenschutzvorschriften anzupassen bzw. zu aktualisieren. Auf diese Weise können wir sie den aktuellen
                rechtlichen Anforderungen anpassen und Änderungen unserer Leistungen berücksichtigen, z. B. bei der Einführung
                neuer Services. Für Ihren Besuch gilt die jeweils aktuelle Fassung.
            </p>
        </v-card-text>
    </v-card>
</template>

<script>
export default {
    name: 'meta-de-data-protection'
}
</script>

<style lang="sass"
       scoped>
  p
    text-align: justify
  a
    text-decoration: none
    color: black
  address
    font-style: normal
</style>
